import { CheckCircleIcon } from "@heroicons/react/24/outline";
import {
  useAcceptUserInvitation,
  useGetUserInvitationCheck,
} from "@via/pages/account/admin/admin.api.tsx";
import { useSearchParams } from "react-router-dom";
import { Spinner } from "@via/components/loading/loading";
import LoginLink from "@via/components/login-link.tsx";

interface StepProps {
  email: string;
}

const GuestConfirmationScreen: React.FC<StepProps> = ({ email }) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { data: invitationDetails } = useGetUserInvitationCheck({
    token: token || "",
  });
  const { mutate: acceptInvitation, isPending: isAcceptingInvitation } =
    useAcceptUserInvitation();

  const handleExplorePlatform = () => {
    if (token) {
      acceptInvitation({ token });
    }
  };

  return (
    <div className="w-full max-w-md p-8 pt-1 space-y-8">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <CheckCircleIcon
            className="h-6 w-6 text-green-600"
            aria-hidden="true"
          />
        </div>
        <h2 className="mt-4 text-2xl font-semibold text-gray-900">
          Almost Done!
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Your account has been created successfully. You&apos;re ready to
          explore the platform.
        </p>
      </div>

      {invitationDetails && (
        <div className="bg-gray-50 rounded-lg p-4">
          <h3 className="text-sm font-medium text-gray-900 mb-2">
            Invitation Details
          </h3>
          <div className="space-y-2 text-sm text-gray-600">
            {invitationDetails.inviterUsername && (
              <div>
                <span className="font-medium">Invited by:</span>{" "}
                {invitationDetails.inviterUsername}
              </div>
            )}
            <div>
              <span className="font-medium">Email:</span> {email}
            </div>
          </div>
        </div>
      )}

      <div className="space-y-4">
        <button
          type="button"
          onClick={handleExplorePlatform}
          disabled={isAcceptingInvitation}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
          <Spinner loading={isAcceptingInvitation}>
            {isAcceptingInvitation
              ? "Accepting Invitation..."
              : "Explore Platform"}
          </Spinner>
        </button>
        <LoginLink logoutBeforeLogin={true} />
      </div>
    </div>
  );
};

export default GuestConfirmationScreen;
